export class BackupLimitations {

  public id: string;
  public deleteCount: number;
  public domainId: number;
  public storage: number;
  public maxStorage: any;
  public updatedAt: Date;
  public createdAt: Date;
  public method: any;

}
